function cov_1r6966fqhx() {
  var path = "/app/src/utils/use-get-payment-schedule-titles.ts";
  var hash = "d8eda4071d4c89f7ba6fd1d1e86a78f50e7ba9f8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/use-get-payment-schedule-titles.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 43
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 12
        },
        end: {
          line: 5,
          column: 23
        }
      },
      "2": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "3": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 16,
          column: 7
        }
      },
      "4": {
        start: {
          line: 11,
          column: 10
        },
        end: {
          line: 11,
          column: 38
        }
      },
      "5": {
        start: {
          line: 13,
          column: 10
        },
        end: {
          line: 13,
          column: 51
        }
      },
      "6": {
        start: {
          line: 15,
          column: 10
        },
        end: {
          line: 15,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 43
          },
          end: {
            line: 4,
            column: 44
          }
        },
        loc: {
          start: {
            line: 4,
            column: 49
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        },
        loc: {
          start: {
            line: 8,
            column: 28
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 10,
            column: 8
          },
          end: {
            line: 11,
            column: 38
          }
        }, {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 13,
            column: 51
          }
        }, {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 15,
            column: 53
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d8eda4071d4c89f7ba6fd1d1e86a78f50e7ba9f8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1r6966fqhx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1r6966fqhx();
import { useCallback } from 'react';
import { useLocale } from 'src/hooks/use-locale';
cov_1r6966fqhx().s[0]++;
export var useGetPaymentScheduleTitles = function useGetPaymentScheduleTitles() {
  cov_1r6966fqhx().f[0]++;
  var t = (cov_1r6966fqhx().s[1]++, useLocale());
  cov_1r6966fqhx().s[2]++;
  return useCallback(function (monthCount) {
    cov_1r6966fqhx().f[1]++;
    cov_1r6966fqhx().s[3]++;
    switch (monthCount) {
      case 0:
        cov_1r6966fqhx().b[0][0]++;
        cov_1r6966fqhx().s[4]++;
        return t('tabbyCard.Today');
      case 1:
        cov_1r6966fqhx().b[0][1]++;
        cov_1r6966fqhx().s[5]++;
        return t('x_months_one', {
          monthCount: monthCount
        });
      default:
        cov_1r6966fqhx().b[0][2]++;
        cov_1r6966fqhx().s[6]++;
        return t('x_months_other', {
          monthCount: monthCount
        });
    }
  }, [t]);
};